<template>
  <b-modal centered
           id="mobile-genre-popup"
           ref="mobile-genre-popup"
           v-bind:visible="showMobileGenrePopup"
           size="lg" scrollable
           title="סגנון טקסט"
           header-class="bg-background"
           hide-header-close>
        <div class="raised-frame">   
            <ul class="chapter2 list-unstyled accordion-list p-0 m-0">
                <li v-for="(textType, textTypeIndex) in textTypes"
                    class="p-3 border-secondary border-bottom"
                    :key="textTypeIndex" @click="chosenTextTypeIndex=textTypeIndex">
                    <b-form-radio v-bind:id="'use-' + textType.name + '-nakdan'"
                                    v-bind:value="textTypeIndex"
                                    v-model="chosenTextTypeIndex">{{ textType.displayText }}
                    </b-form-radio>
                </li>
            </ul>
        </div>    
        <template v-slot:modal-footer>
            <b-button
                block
                variant="primary"
                size="lg"
                @click="saveChangesClicked">שמור שינויים
            </b-button>
        </template>
  </b-modal>
</template>

<script>
    // @ is an alias to /src
    import {AppConfig as appConfig} from '../appConfig'
    import {NakdanType} from '@/simpleVsProConfig.js'
    import {BlankState} from '@/store/stateChanges'
    import serviceMixins from '@/mixins/serviceMixins'

    const textTypes = [
                    {
                        name: 'modern',
                        displayText: 'טקסט מודרני'
                    },
                    {
                        name: 'rabbinic',
                        displayText: 'טקסט רבני'
                    },
                    {
                        name: 'poetry',
                        displayText: 'טקסט שירה'
                    }
                ]
    if (appConfig.INCLUDE_TALMUD_GENRE) textTypes.push({
        name: 'talmud',
        displayText: 'טקסט מהתלמוד'
    })

    export default {
        name: 'DocumentSettingsGenre',
        data() {
            return {
                chosenTextTypeIndex: textTypes.map(t => t.name).indexOf(this.$store.state.preSubmissionOptions.chosenTextTypeName),
                textTypes: textTypes
            }
        },
        props: ['showMobileGenrePopup'],
        mixins: [serviceMixins], // for gtag()
        computed: {
            nakdanType () {
                return NakdanType
            },
            chosenTextType: function () {
                return this.textTypes[this.chosenTextTypeIndex]
            }
        },
        watch: {
            showMobileGenrePopup (newShowMobileGenrePopup) {
                if (newShowMobileGenrePopup) this.$refs['mobile-genre-popup'].show()
            }
        },
        methods: {
            saveChangesClicked () {
                var options = this.$store.state.preSubmissionOptions
                options.chosenTextTypeName = textTypes[this.chosenTextTypeIndex].name
                const nonDefaultOptions = Object.keys(BlankState.preSubmissionOptions).filter(
                    k => options[k] !== BlankState.preSubmissionOptions[k]
                ).map(k => k + ': ' + options[k])
                this.gtag("event", "options for nikud set", {
                    'event_category': 'user input',
                    'event_label': 'non-default options: ' + (
                        nonDefaultOptions.length ? nonDefaultOptions.join(', ') : 'none')
                })
                this.$store.commit('STORE_ALL_FRONTEND_NIKUD_OPTIONS', options)
                this.$refs['mobile-genre-popup'].hide()
            }
        }
    }
</script>

<style>
   #mobile-genre-popup .custom-control-label:after, #mobile-genre-popup .custom-control-label:before {
        top: 0;
        width: 1.5rem;
        height: 1.5rem;
    }
    #mobile-genre-popup .custom-control-label {
        padding-right:10px;
    }
</style>
<style scoped>
    /* DocumentSettingsGenre-specific CSS goes here */
    .text-type {
        display: flex;
        margin: 10px;
    }
    .raised-frame{
        margin: 10px 0 100px 0
    }
    .accordion-body-heading {
        margin: 0 0 5px;
    }
    .accordion-list {
        margin: 0 10px;
        padding: 0;
    }
    button{
        font-size:18px;
    }
</style>
